import React, { useState } from 'react'
import { get } from '../lib/api';
const aiUgcNumbers = [
  "+919717814604",
  "+919674994218",
  "+919289678904",
  "+919810653302",
  "+919687205644",
  "+916388305387",
  "+919851835595",
  "+919102599052",
  "+916396641802",
  "+919041775517",
  "+919027309240",
  "+918200798978",
  "+919173431534",
  "+918610175684",
  "+919695478677",
  "+919674994218",
  "+919900002000",
  "+919879998977",
  "+918200596953"
];

// Now 'numbers' is an array containing the phone numbers with the "+91" prefix without a space.


const AccountContext = React.createContext({
  user: {},
  onUpdateUser: () => {},
})

const AccountProvider = ({ userData, children }) => {
  const [user, updateUser] = useState(userData || {})
  const [isUgcUser, setIsUgcUser] = useState(false)
  const [isHindiUgcUser, setIsHindiUgcUser] = useState(false)
  const [isClarityEnabled, setClarityEnabled] = useState(false);
  const handleUpdateUser = data => {
    updateUser(data)
    setIsUgcUser(data?.location && data?.languages === 'english')
    const isUIDPresent = aiUgcNumbers.includes(data?.phone_number)
    get(`/user_api/user.is_hindi_ugc_beta_user?uid=${data?.uid || localStorage.getItem('uid')}`).then((res) =>  setIsHindiUgcUser(res?.beta_user === 1 && data?.location && data?.location === 'IN' && data?.languages === 'hindi'))
   
  }

  return (
    <AccountContext.Provider
      value={{
        user,
        isUgcUser,
        isClarityEnabled, 
        setClarityEnabled,
        isHindiUgcUser,
        onUpdateUser: handleUpdateUser
      }}
    >
      {children}
    </AccountContext.Provider>
  )
}

export { AccountContext }
export default AccountProvider
